import { Navigate, createBrowserRouter } from 'react-router-dom';
import { USER_ROLES } from '@/constants/roles';
import { ROUTES, getHomePath } from '@/constants/routes';
import { AdminLayout } from '@/layouts/AdminLayout';
import { DepartmentManagementPage } from '@/pages/admin/departments/DepartmentManagementPage';
import { ProjectReportManagementPage } from '@/pages/admin/project-reports/ProjectReportManagementPage';
import { ProjectCreatePage } from '@/pages/admin/projects/ProjectCreatePage';
import { ProjectDetailPage } from '@/pages/admin/projects/ProjectDetailPage';
import { ProjectListPage } from '@/pages/admin/projects/ProjectListPage';
import { ReportManagementPage } from '@/pages/admin/reports/ReportManagementPage';
import { TaskManagementPage } from '@/pages/admin/tasks/TaskManagementPage';
import { UserManagementPage } from '@/pages/admin/users/UserManagementPage';
import { PlaceholderPage } from '@/pages/common/PlaceholderPage';
import { LoginPage } from '@/pages/login/LoginPage';
import { AuthGuard } from '@/router/guards/AuthGuard';
import { GuestGuard } from '@/router/guards/GuestGuard';
import { RoleGuard } from '@/router/guards/RoleGuard';
import { selectIsAuthenticated, useAuthStore } from '@/stores/auth.store';

function RootRedirect() {
  const isAuthenticated = useAuthStore(selectIsAuthenticated);
  const user = useAuthStore((state) => state.user);

  if (!isAuthenticated || !user) {
    return <Navigate to={ROUTES.login} replace />;
  }

  return <Navigate to={getHomePath(user)} replace />;
}

export const router = createBrowserRouter([
  {
    path: '/',
    element: <RootRedirect />,
  },
  {
    path: ROUTES.login,
    element: (
      <GuestGuard>
        <LoginPage />
      </GuestGuard>
    ),
  },
  {
    path: ROUTES.admin.root,
    element: (
      <AuthGuard>
        <RoleGuard allowedRoles={[USER_ROLES.ADMIN]}>
          <AdminLayout />
        </RoleGuard>
      </AuthGuard>
    ),
    children: [
      {
        index: true,
        element: <Navigate to={ROUTES.admin.dashboard} replace />,
      },
      {
        path: 'dashboard',
        element: <PlaceholderPage title="管理员工作台" description="业务页面开发中" />,
      },
      {
        path: 'departments',
        element: <DepartmentManagementPage />,
      },
      {
        path: 'users',
        element: <UserManagementPage />,
      },
      {
        path: 'tasks',
        element: <TaskManagementPage />,
      },
      {
        path: 'reports',
        element: <ReportManagementPage />,
      },
      {
        path: 'project-reports',
        element: <ProjectReportManagementPage />,
      },
      {
        path: 'projects',
        element: <ProjectListPage />,
      },
      {
        path: 'projects/create',
        element: <ProjectCreatePage />,
      },
      {
        path: 'projects/:id',
        element: <ProjectDetailPage />,
      },
    ],
  },
  {
    path: '*',
    element: <Navigate to="/" replace />,
  },
]);
